<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M5.17502,7.00412C5.58809,5.83779,6.69908,5.00253,8.00478,5.00253C9.31047,5.00253,10.4215,5.83779,10.8345,7.00412C10.8345,7.00412,12.8202,7.00412,12.8202,7.00412C11.9241,6.248279999999999,11.419,5.81149,11.3048,5.69375C11.1336,5.5171399999999995,11.0125,5.26241,11.0125,4.988613C11.0125,4.450798,11.466,4,12.0027,4C12.276,4,12.5234,4.108119,12.699,4.29391C12.8161,4.41777,13.8189,5.42308,15.7072,7.30983C15.8829,7.48584,16,7.7205200000000005,16,7.99432C16,8.26812,15.8926,8.51258,15.717,8.68859C15.717,8.68859,12.7038,11.71642,12.7038,11.71642C12.5281,11.89244,12.2841,12,12.0108,12C11.4587,12,11.0125,11.55264,11.0125,11.01482C11.0125,10.741019999999999,11.1292,10.47014,11.3048,10.29412C11.3048,10.29412,12.8202,9.00151,12.8202,9.00151C12.8202,9.00151,10.8397,9.00151,10.8397,9.00151C10.4307,10.17548,9.31593,11.01774,8.00478,11.01774C6.69362,11.01774,5.5788,10.17548,5.16988,9.00151C5.16988,9.00151,3.1798,9.00151,3.1798,9.00151C3.1798,9.00151,4.69516,10.29412,4.69516,10.29412C4.87083,10.47014,4.98746,10.741019999999999,4.98746,11.01482C4.98746,11.55264,4.54128,12,3.98916,12C3.71589,12,3.4719,11.89244,3.29623,11.71642C3.29623,11.71642,0.283027,8.68859,0.283027,8.68859C0.107355,8.51258,0,8.26812,0,7.99432C0,7.7205200000000005,0.117115,7.48584,0.292787,7.30983C2.18113,5.42308,3.18385,4.41777,3.30097,4.29391C3.47664,4.108119,3.724,4,3.99727,4C4.53405,4,4.98746,4.450798,4.98746,4.988613C4.98746,5.26241,4.86637,5.5171399999999995,4.69516,5.69375C4.58101,5.81149,4.0759,6.248279999999999,3.1798,7.00412C3.1798,7.00412,5.17502,7.00412,5.17502,7.00412C5.17502,7.00412,5.17502,7.00412,5.17502,7.00412Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'FlowReview',
} as DefineComponent
</script>
